"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getErrorsInfo = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _reactHookForm = require("react-hook-form");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    errorPos: {
      fontStyle: 'italic',
      color: palette.grey.main,
      fontSize: 14,
      lineHeight: '18px',
      display: 'flex'
    },
    goToLineButton: {
      color: palette.link.main,
      fontSize: 14,
      lineHeight: '18px',
      minWidth: 'initial',
      padding: spacing(0, 0.5),
      '&:hover': {
        background: 'transparent'
      }
    }
  };
});

var getErrorsInfo = function getErrorsInfo(errors) {
  var _errors$contacts, _errors$contacts2;

  if (!errors.contacts || !Array.isArray(errors.contacts)) {
    return {
      total: 0,
      indexes: []
    };
  }

  var total = errors === null || errors === void 0 ? void 0 : (_errors$contacts = errors.contacts) === null || _errors$contacts === void 0 ? void 0 : _errors$contacts.reduce(function (acc, item) {
    return item ? acc + Object.keys(item).length : acc;
  }, 0);
  var indexes = errors === null || errors === void 0 ? void 0 : (_errors$contacts2 = errors.contacts) === null || _errors$contacts2 === void 0 ? void 0 : _errors$contacts2.map(function (_, index) {
    return index;
  });
  return {
    total,
    indexes
  };
};

exports.getErrorsInfo = getErrorsInfo;

var ContactsTableErrors = function ContactsTableErrors(_ref2) {
  var contactsCount = _ref2.contactsCount,
      control = _ref2.control,
      onGoToLine = _ref2.onGoToLine;
  var classes = useStyles();

  var _useFormState = (0, _reactHookForm.useFormState)({
    control
  }),
      errors = _useFormState.errors;

  var hasErrors = Boolean((errors === null || errors === void 0 ? void 0 : errors.contacts) && (errors === null || errors === void 0 ? void 0 : errors.contacts.length) > 0);

  var _getErrorsInfo = getErrorsInfo(errors),
      total = _getErrorsInfo.total,
      indexes = _getErrorsInfo.indexes;

  var goToErrorHandler = (0, _react.useCallback)(function (_ref3) {
    var currentTarget = _ref3.currentTarget;
    var index = currentTarget.dataset.index;
    onGoToLine(Number(index));
  }, [onGoToLine]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    px: 2,
    pt: 3,
    pb: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    gutterBottom: true
  }, "Total Contacts:", ' ', /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "span",
    fontWeight: "bold"
  }, contactsCount), ' ', hasErrors && /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "span",
    fontWeight: "bold"
  }, "(", total, " errors)")), hasErrors && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    gutterBottom: true
  }, indexes.map(function (errorLine) {
    return /*#__PURE__*/_react.default.createElement(_ui.Button, {
      variant: "text",
      key: errorLine,
      "data-index": errorLine,
      onClick: goToErrorHandler,
      className: classes.goToLineButton
    }, errorLine + 1);
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(ContactsTableErrors);

exports.default = _default;